// Set from the config table in views/header/react.php. Anything bad means off, never up.
const toRate = (value) =>
  typeof value === "number" && value >= 0 && value <= 1 ? value : 0;

export const getSentrySampleRates = () => {
  const rates = window.__SENTRY_SAMPLE_RATES__ || {};

  return {
    tracesSampleRate: toRate(rates.tracesSampleRate),
    profileSessionSampleRate: toRate(rates.profileSessionSampleRate),
  };
};
